module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "home-title"
  }, [_vm._v("\n      What is my balance?\n    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\n      Your balance can be viewed in the top right of this application"), _c('br'), _vm._v("\n      Currently, you have\n      "), _c('span', {
    staticClass: "tag is-info"
  }, [_vm._v(_vm._s(_vm.assets.blue))]), _vm._v(" blue E-Coins,\n      and "), _c('span', {
    staticClass: "tag is-danger"
  }, [_vm._v(_vm._s(_vm.assets.red))]), _vm._v(" red E-Coins\n    ")])]), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-primary"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('h1', {
    staticClass: "title is-4"
  }, [_vm._v("\n        Welcome to the management platform of your E-Coins!\n      ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "home-title is-4"
  }, [_vm._v("\n      What's the point?\n    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\n      The purpose of the E-Coin is currently peer recognition (and by E-Corp).\n      Thus, when a collaborator makes a gesture to you that is useful to you in your work,\n      you can transfer him E-Coins.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      For example, Alice unlocked Bob in his understanding of the latest fashionable framework,\n      so to thanks her, Bob transferred her 3 E-Coins.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      There is no grid to know how many E-Coins give for a specific service.\n      This choice is personal. Besides, nothing forces you to give E-Coins.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "home-title"
  }, [_vm._v("\n      Blue, Red…?!\n    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("\n      E-Coin exists in different colors. Currently, only blue and red are available.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      The "), _c('span', {
    staticClass: "tag is-info"
  }, [_vm._v("Blue")]), _vm._v(" color corresponds to the normal reward given\n      to all E-Corp employees.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      The "), _c('span', {
    staticClass: "tag is-danger"
  }, [_vm._v("Red")]), _vm._v(" color can be obtain when someone gives you some E-Coins.\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      The "), _c('span', {
    staticClass: "tag is-danger"
  }, [_vm._v("Red")]), _vm._v(" are the proof of services you gived to\n      E-Corp.\n      These are the E-Coins you can be proud of! Including in HR interview ;)\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', [_vm._v("How it works?")]), _vm._v(" "), _c('p', [_vm._v("\n      E-Coins are assets on a blockchain similar to\n      "), _c('a', {
    attrs: {
      "href": "https://fr.wikipedia.org/wiki/Bitcoin"
    }
  }, [_vm._v("Bitcoin")]), _vm._v(",\n      built with "), _c('a', {
    attrs: {
      "href": "https://www.multichain.com/"
    }
  }, [_vm._v("Multichain")]), _vm._v(" "), _c('br'), _vm._v("\n      More information about this project can be found in\n      "), _c('a', {
    attrs: {
      "href": "https://github.com/flibustier/e-coin"
    }
  }, [_vm._v("this repository")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-246bbd84","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 157
// module chunks = 0